import { Link } from "react-router-dom";
import {
    Facebook,
    Instagram,
    Youtube,
    Twitter,
    MapPin,
    Phone,
    Mail,
    MessageCircle
} from "lucide-react";



import whatsapps from "../accests/common/whatsapp.png";

export default function Footer() {
    return (
        <footer className="bg-gradient-to-b from-gray-950 to-gray-900 text-gray-300">

            {/* MAIN FOOTER */}
            <div className="max-w-7xl mx-auto px-6 py-16 grid gap-12 md:grid-cols-4">

                {/* BRAND */}
                <div>
                    <h2 className="text-3xl font-bold text-yellow-400 mb-4">
                        Ranmali Tours
                    </h2>
                    <p className="text-sm leading-relaxed">
                        Discover Sri Lanka with premium tour experiences, local expertise,
                        and unforgettable journeys made just for you.
                    </p>

                    {/* SOCIAL ICONS */}
                    <div className="flex gap-4 mt-6">
                        <a href="https://www.facebook.com/share/18DNkUtQAg/" className="footer-icon"><Facebook size={18} /></a>
                        <a href="https://www.instagram.com/ranmali_tours/" className="footer-icon"><Instagram size={18} /></a>
                        <a href="https://www.youtube.com/channel/UCQ1iiwfILVXqS6JubthH0mw" className="footer-icon"><Youtube size={18} /></a>



                    </div>
                </div>

                {/* QUICK LINKS */}
                <div>
                    <h3 className="font-semibold text-lg mb-4">Quick Links</h3>
                    <ul className="space-y-3 text-sm">
                        <li><a href="/" className="hover:text-yellow-400">Home</a></li>
                        <li><a href="/about" className="hover:text-yellow-400">About</a></li>
                        <li><a href="/tours" className="hover:text-yellow-400">Tours</a></li>
                        <li><a href="/gallery" className="hover:text-yellow-400">Gallery</a></li>
                        <li><a href="/contact" className="hover:text-yellow-400">Contact</a></li>
                    </ul>
                </div>

                {/* POPULAR TOURS */}
                <div>
                    <h3 className="font-semibold text-lg mb-4">Popular Tours</h3>
                    <ul className="space-y-3 text-sm">
                        <li>
                            <Link
                                to="/tours/day-tours/galle-day-tour"
                                className="hover:text-yellow-400 transition"
                            >
                                Galle Day Tour
                            </Link>
                        </li>
                        <li>
                            <Link
                                to="/tours/day-tours/kandy-day-tour"
                                className="hover:text-yellow-400 transition"
                            >
                                Kandy Day Tour
                            </Link>
                        </li>
                        <li>
                            <Link
                                to="/tours/day-tours/udawalawe-day-tour"
                                className="hover:text-yellow-400 transition"
                            >
                                Udawalawe Day Tour
                            </Link>
                        </li>
                        <li>
                            <Link
                                to="/tours/day-tours/yala-day-tour"
                                className="hover:text-yellow-400 transition"
                            >
                                Yala Day Tour
                            </Link>
                        </li>
                        <li>
                            <Link
                                to="tours/day-tours/sigiriya-dambulla-day-tour"
                                className="hover:text-yellow-400 transition"
                            >
                                Sigiriya Dambulla Day Tour
                            </Link>
                        </li>
                        <li>
                            <Link
                                to="/tours/day-tours/whale-watching-mirissa"
                                className="hover:text-yellow-400 transition"
                            >
                                Whale Watching Mirissa
                            </Link>
                        </li>
                        <li>
                            <Link
                                to="/tours/day-tours/pinnawala-elephant"
                                className="hover:text-yellow-400 transition"
                            >
                                Pinnawala Elephant Tour
                            </Link>
                        </li>
                        <li>
                            <Link
                                to="/tours/day-tours/kithulgala-rafting"
                                className="hover:text-yellow-400 transition"
                            >
                                Kithulgala Rafting
                            </Link>
                        </li>
                        <li>
                            <Link
                                to="/tours/day-tours/sinharaja-day-tour"
                                className="hover:text-yellow-400 transition"
                            >
                                Sinharaja Day Tour
                            </Link>
                        </li>
                        <li>
                            <Link
                                to="/tours/day-tours/bentota-fishing"
                                className="hover:text-yellow-400 transition"
                            >
                                Bentota Fishing
                            </Link>
                        </li>
                    </ul>
                </div>


                {/* CONTACT */}
                <div>
                    <h3 className="font-semibold text-lg mb-4">Contact</h3>
                    <p className="flex items-center gap-2 text-sm mb-3">
                        <MapPin size={16}/> Sri Lanka
                    </p>
                    <p className="flex items-center gap-2 text-sm mb-3">
                        <Phone size={16} /> +94 77 016 3670
                    </p>
                    <p className="flex items-center gap-2 text-sm">
                        <Mail size={16} /> ranmalitours@gmail.com
                    </p>
                </div>
            </div>

            {/* FLOATING WHATSAPP BUTTON */}
            <a
                href="https://wa.me/94770163670?text=Hello, I would like to get in touch with you."
                target="_blank"
                rel="noopener noreferrer"
                className="fixed bottom-4 right-4 w-12 h-12 rounded-full bg-green-500 flex items-center justify-center animate-pulse hover:scale-110 transition-transform z-50"
            >
                <img src={whatsapps} alt="WhatsApp" className="w-6 h-6" />
            </a>

            {/* BOTTOM */}
            <div className="border-t border-white/10 text-center py-6 text-sm text-gray-500">
                © {new Date().getFullYear()} Ranmali Tours. All Rights Reserved.
            </div>
        </footer>
    );
}
